import React, { useEffect, useState } from "react";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
import {
    errorMessage,
    formatAmount,
    formatDate,
    formatStatus,
    ucFirst,
} from "../../../../util/Helpers";
import SimpleTable from "my-simple-react-table";
import { BackIcon, SubscriptionIcon, ViewIcon } from "../../../../util/Icons";
import { Permission } from "../../../Common/layout/Permission";
import { Permissions, PermissionType } from "../../../../util/Permissions";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { BillingDetails } from "./components/BillingDetails";

const ViewSubscriptionModal = ({ showViewSubscriptionModal, details, onHide }) => {
    const [showBillingDetails, setShowBillingDetails] = useState({
        show: false,
        details: null
    })

    const toggleShowBillingDetails = (row) => {
        setShowBillingDetails({ details: row, show: !showBillingDetails.show })
    }

    useEffect(() => {
        setShowBillingDetails({ details: null, show: false })
    }, [showViewSubscriptionModal])

    const billingAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Permission permission={Permissions.SUBSCRIPTIONS} permissionType={PermissionType.READ}>
                    <Button
                        title="View Billing"
                        className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                        onClick={() => toggleShowBillingDetails(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <ViewIcon />
                        </span>
                    </Button>
                </Permission>
            </span>
        )
    }

    return (
        <Modal
            show={showViewSubscriptionModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SubscriptionIcon />
                    </span>
                    Subscription Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="p-0"
            >
                <Tab.Container defaultActiveKey={""}>
                    <Nav
                        className="d-flex w-100 px-4 border-bottom align-items-center bg-white position-sticky top-0"
                        style={{
                            height: "46px",
                            zIndex: 1
                        }}
                    >
                        <Nav.Item>
                            <Nav.Link className="px-3" eventKey={""}>
                                <div>Details</div>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className="px-3" eventKey={"activities"}>
                                <div>Activities</div>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className="px-3" eventKey={"billings"}>
                                <div>Billings</div>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content className={"h-100 mx-7 mb-7"}>
                        <Tab.Pane eventKey={""} className={"h-100"}>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>Product</h6>
                                    <span className="text-muted">{details?.product}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Sub Key</h6>
                                    <span className="text-muted">{details?.subKey}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Status</h6>
                                    {formatStatus(details?.status)}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>User ID</h6>
                                    <span className="text-muted">{details?.userId}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Account ID</h6>
                                    <span className="text-muted">{details?.accountId}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg py-4">
                                    <h6>Due Date</h6>
                                    <span className="text-muted">{formatDate(details?.dueDate)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Created At</h6>
                                    <span className="text-muted">{formatDate(details?.created)}</span>
                                </div>
                                <div className="col-lg py-4">
                                    <h6>Updated At</h6>
                                    <span className="text-muted">{formatDate(details?.updated)}</span>
                                </div>
                            </div>
                            <div className="row">
                                {
                                    Object.keys(details?.model || {}).map((key) => (
                                        <div key={key} className="col-3 py-4">
                                            <h6>{ucFirst(key)}</h6>
                                            <span className="text-muted">{details?.model[key].toString()}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey={"activities"} className={"h-100"}>
                            <SimpleTable
                                data={details?.activity || []}
                                columns={[
                                    { title: "ACTIVITY", key: "activity" },
                                    { title: "DATE", format: row => formatDate(row.date) },
                                    { title: "STATUS", format: row => formatStatus(row.status) },
                                ]}
                                searchBox={false}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey={"billings"} className={"h-100"}>
                            {
                                showBillingDetails.show
                                    ? <>
                                        <div className="py-4 d-flex align-items-center border-bottom">
                                            <Button
                                                variant="dark"
                                                size="sm"
                                                className="d-flex align-items-center"
                                                onClick={() => toggleShowBillingDetails(null)}
                                            >
                                                <BackIcon />
                                                <span className="mx-2">Back</span>
                                            </Button>
                                            <h4 className="ml-4 mb-0">{showBillingDetails?.details?.ref}</h4>
                                        </div>
                                        <BillingDetails details={showBillingDetails?.details} />
                                    </>
                                    : <DynamicSimpleTable
                                        key={`${details?.userGroup}-billings`}
                                        queryParams={
                                            `userGroup=${details?.userGroup}`
                                            + `&subId=${details?.id}`
                                            + `&limit=10`
                                        }
                                        searchBox={false}
                                        source={{ url: `/subscriptions/billings` }}
                                        columns={[
                                            { title: "REFERENCE", key: "ref" },
                                            { title: "PRICE", format: row => formatAmount(row.currency, row.price) },
                                            { title: "CHARGE AMOUNT", format: row => formatAmount(row.currency, row.chargeAmount) },
                                            { title: "STATUS", format: row => formatStatus(row.status) },
                                            { title: "UPDATED AT", format: (row) => formatDate(row.updated) },
                                            { title: "", format: billingAction }
                                        ]}
                                        onError={(err) =>
                                            cogoToast.error(errorMessage(err))
                                        }
                                        refreshIcon={true}
                                    />
                            }
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Modal.Body>
        </Modal>

    );
}

export default ViewSubscriptionModal;